import {
  getStoredUTMParams,
  getUTMParams,
  saveUTMParams,
} from '@/utils/analytics';

type TrackingContext = Record<string, string>;

function filterTruthyStringValues(values: object): TrackingContext {
  return Object.fromEntries(
    Object.entries(values).filter(
      ([, value]) => typeof value === 'string' && Boolean(value),
    ),
  ) as TrackingContext;
}

/**
 * 모듈 로드 시점에 이벤트 공통 문맥으로 사용할 UTM을 계산합니다.
 *
 * - 현재 URL의 UTM이 있으면 저장소에 merge 저장
 * - 없으면 기존 stored UTM 유지
 * - 이벤트 payload에는 truthy value만 포함
 */
export function getInitialQuizTrackingState(): TrackingContext {
  if (typeof window === 'undefined') return {};

  try {
    const stored = getStoredUTMParams();
    const current = getUTMParams();
    const hasCurrent = Object.values(current).some(Boolean);
    const merged = hasCurrent ? saveUTMParams(current) : stored;

    return filterTruthyStringValues(merged);
  } catch {
    return {};
  }
}

/**
 * user property로 기록할 stored UTM만 추출합니다.
 */
export function getStoredQuizTrackingUserProperties(): TrackingContext {
  if (typeof window === 'undefined') return {};

  try {
    return filterTruthyStringValues(getStoredUTMParams());
  } catch {
    return {};
  }
}
